import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import AuthorizePage from './pages/Authorize';
import ErrorPage from './pages/ErrorPage';
import OIDCCallbackPage from './pages/OIDCCallback';

const router = createBrowserRouter([
  {
    path: "/authorize",
    element: (<AuthorizePage />),
    errorElement: (<ErrorPage />)
  },
  {
    path: "/oidc/callback",
    element: (<OIDCCallbackPage />),
    errorElement: (<ErrorPage />)
  },
  {
    path: "*",
    element: (<ErrorPage />),
    errorElement: (<ErrorPage />)
  }
]);

ReactDOM.render(
  <React.StrictMode>
    <RouterProvider router={router} fallbackElement={ErrorPage} />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
